module.exports = __webpack_public_path__ + "static/Klaviyo-bf2170d1daf7a4bd0f78aeb4b3279deb.jpg";